<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import { BaseAtom } from "components/cards/atoms";
export let container = undefined;
export let innings = undefined;
export let selectedInningIndex = undefined;
export let expandedOverIndex = undefined;
export let tabsStripContainer = undefined;
export let tabContainer = undefined;
export let selectedTabContainer = undefined;
export let overContainer = undefined;
export let ballRowContainer = undefined;
export let badgeSize = undefined;
export let badgeRadius = undefined;
export let badgeSizeCompact = undefined;
export let badgeRadiusCompact = undefined;
export let badgeTextColorBoundary = undefined;
export let badgeTextColorWicket = undefined;
export let badgeTextColorRuns = undefined;
export let badgeTextColorExtras = undefined;
export let chevronSize = undefined;
export let chevronColor = undefined;
export let gapBallStrip = undefined;
export let gapOverMeta = undefined;
export let gapBallRow = undefined;
export let showOverDivider = undefined;
export let showCommentaryDivider = undefined;
export let commentaryDividerColor = undefined;
export let txtInningTab = undefined;
export let selectedTxtInningTab = undefined;
export let txtOverLabel = undefined;
export let txtOverSummary = undefined;
export let txtBadgeSm = undefined;
export let txtBadgeLg = undefined;
export let txtTimestamp = undefined;
export let txtMatchup = undefined;
export let txtRunsLabel = undefined;
export let txtCommentary = undefined;
</script>

<BaseAtom
  _isotope="BallByBallCardAtom"
  {...container}
  _cssVariablePrefix="ball-by-ball-card"
>
  ball by ball card
</BaseAtom>

<style>
  .ball-by-ball-card {
    width: 100%;
  }</style>
